import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import Sidenav from "../component/Sidenav";
import HeaderAdm from "../component/HeaderAdm";
import OffcanvasMenu from "../component/OffcanvasMenu";
import Breadcrumbs from "../component/Breadcrumbs";
import "../styles/layout.css";

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleResize = useCallback(() => {
    if (window.innerWidth <= 1024) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Container fluid className="layout-container d-flex">
      <Sidenav
        collapsed={collapsed}
        toggleSidebar={toggleSidebar}
        handleShow={handleShow}
      />
      <div className={`main-area ${collapsed ? "collapsed" : ""}`}>
        <HeaderAdm handleShow={handleShow} />
        <Row className="main-content d-flex flex-column align-items-center justify-content-center p-4">
          <Col md={12}><Breadcrumbs /></Col>
          <Outlet />
        </Row>
      </div>
      <OffcanvasMenu
        show={showOffcanvas}
        handleClose={handleClose}
        collapsed={collapsed}
        toggleSidebar={toggleSidebar}
      />
    </Container>
  );
};

export default Layout;
